import AuthForm from '../components/Auth/AuthForm'

function Auth() {
    return <AuthForm />
}

export default Auth
